<template>
  <div>
    <head-nav-bar title="办理入住" :fixed="true" />
    <div class="mt-header-nav">
      <van-row style="font-size: 14px;">
        <van-col span="12" style="color: #999999;">房间列表</van-col>
        <van-col span="12" class="allSelect" @click="selectRoom = []">
          全不选
        </van-col>
      </van-row>
      <van-checkbox-group v-model="selectRoom">
        <van-row v-for="(item, index) in CheckInDetails" :key="index">
          <van-col span="13">
            {{ item.RoomTypeName }}-
            <van-button
              type="info"
              size="mini"
              @click="onSelectRoom(item.OrderDetailId)"
            >
              {{ !item.RoomNo ? "未排房" : item.RoomNo }}
            </van-button>
          </van-col>
          <van-col span="9">
            <van-button type="info" size="mini" @click="updateIdCard(item)">
              证件*{{ item.People.length }}
            </van-button>
          </van-col>
          <van-col span="2" style="margin-top: 5px;">
            <van-checkbox
              :name="item.OrderDetailId"
              style="margin-top: -3px;"
            />
          </van-col>
        </van-row>
      </van-checkbox-group>

      <van-row>
        <van-col span="12" style="color: #999999;font-size: 14px;">
          付款方式
        </van-col>
      </van-row>
      <van-row>
        <van-col span="12" style="color: #999999;">
          消费金额：<span style="color:red">
            {{ orderInfo.TotalAmount }}
          </span>
        </van-col>
        <van-col span="12" style="color: #999999;">
          已收金额：<span style="color:red">
            {{ orderInfo.AlreadyPayAmount }}
          </span>
        </van-col>
      </van-row>

      <pay ref="pay" @submit="onSubmit" />

      <van-popup v-model="showPicker" position="bottom">
        <van-picker
          show-toolbar
          value-key="No"
          :columns="roomArr"
          @cancel="showPicker = false"
          @confirm="onConfirmRoom"
        />
      </van-popup>

      <van-popup
        v-model="showContact"
        close-icon-position="top-left"
        position="top"
        closeable
        @close="showContact = false"
        :style="{ height: '100%' }"
      >
        <AddPerson :data="currentPersons"></AddPerson>
      </van-popup>
    </div>
  </div>
</template>

<script>
import orderApi from "../../../api/order.js";
import roomApi from "../../../api/room.js";
import pay from "../Pay";
import AddPerson from "../../room/roomComponent/AddPerson";
import { jump } from "../../../utils/common";
import { mapState } from "vuex";
import {
  Row,
  Col,
  Checkbox,
  CheckboxGroup,
  Button,
  Notify,
  Picker,
  Popup,
} from "vant";
import moment from "moment";

export default {
  name: "OrderCheckIn",
  components: {
    pay,
    AddPerson,
    [Row.name]: Row,
    [Col.name]: Col,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Button.name]: Button,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
  },
  data() {
    return {
      orderId: null,
      orderInfo: {}, //订单信息
      selectRoom: [], //当前选择的房间
      roomNoList: [], //房间列表
      roomArr: [], //选择房间列表
      CheckInDetails: [],
      showPicker: false,
      detailId: null, //记录当前操作的明细
      showContact: false,
      currentPersons: [],
    };
  },
  model: {},
  created() {
    this.orderId = this.$route.query.id;
    this.init();
  },
  mounted() {},
  computed: {
    ...mapState({
      user: state => state.user.info,
    }),
  },
  watch: {},
  methods: {
    init() {
      orderApi.getOrderDetail({ id: this.orderId }).then(res => {
        this.orderInfo = res.Data;
        //获取可入住的房间
        res.Data.Details.forEach(item => {
          if (
            item.OrderStatus == "0" &&
            moment(item.CheckInDate).isSameOrBefore(this.user.AccountDate)
          ) {
            //在住状态的房间不能办理入住
            this.CheckInDetails.push({
              OrderDetailId: item.Id,
              Status: item.OrderStatus,
              RoomId: item.RoomId,
              RoomTypeId: item.RoomTypeId,
              RoomNo: item.RoomNo ? item.RoomNo : "",
              RoomTypeName: item.RoomTypeName,
              // RoomNoSelect: [], //可选的房号列表
              CheckInTime: item.CheckInTime,
              CheckOutTime: item.CheckOutTime,
              People: item.Persons,
            });
          }
        });
        //只有一间房间时默认选中
        if (this.CheckInDetails.length == 1) {
          this.selectRoom.push(this.CheckInDetails[0].OrderDetailId);
        }
        //未排房的，获取可选房间
        this.CheckInDetails.forEach(item => {
          // if (!item.RoomId || item.RoomId == "0") {
          let params = {
            OrderId: this.orderId,
            RoomTypeId: item.RoomTypeId,
            CheckInTime: item.CheckInTime,
            CheckOutTime: item.CheckOutTime,
          };
          roomApi.GetRoomAvailable(params).then(res => {
            let RoomNoSelect = res.Data ? res.Data.RoomNos : {};
            this.roomNoList.push({
              Id: item.OrderDetailId,
              RoomNoSelect: RoomNoSelect,
            });
          });
          // }
        });
      });
    },
    onSelectRoom(id) {
      this.detailId = id;
      let detail = this.roomNoList.find(p => p.Id == id);
      // this.roomArr = [];
      // detail.RoomNoSelect.forEach(item => {
      //   this.roomArr.push(item);
      // });
      this.roomArr = detail.RoomNoSelect;
      this.showPicker = true;
    },
    onConfirmRoom(value) {
      let detail = this.CheckInDetails.find(
        p => p.OrderDetailId == this.detailId,
      );
      detail.RoomId = value.Id;
      detail.RoomNo = value.No;
      detail.RoomTypeId = value.RoomTypeId;
      this.showPicker = false;
    },
    updateIdCard(item) {
      this.detailId = item.Id;
      this.currentPersons = item.People;
      this.showContact = true;
    },
    onSubmit(payInfo) {
      if (this.selectRoom.length <= 0) {
        Notify("请选择入住房间");
        return false;
      }
      let checkInDetails = this.CheckInDetails.filter(item => {
        if (this.selectRoom.includes(item.OrderDetailId)) return item;
      });
      //查询勾选的明细 是否存在未排房
      let detail = checkInDetails.find(p => p.RoomId == "0" || !p.RoomId);
      if (detail) {
        Notify("您选择的" + detail.RoomTypeName + "未排房");
        return false;
      }
      if (!payInfo[0].AccountItemId && Number(payInfo[0].Money) != 0) {
        Notify("请选择付款方式");
        return false;
      }
      payInfo[0].GuestId = this.CheckInDetails[0].People[0].Id;
      payInfo[0].OrderId = this.orderId;
      let params = {
        CheckInDetails: checkInDetails,
        PayWays: Number(payInfo[0].Money) != 0 ? payInfo : [],
      };
      console.log(params);
      orderApi.checkIn(params).then(() => {
        Notify({ type: "success", message: "成功办理入住" });
        jump("OrderDetail", { id: this.orderId });
      });
    },
  },
};
</script>

<style lang="less" scoped>
.van-row {
  padding: 3px 10px;
}
.allSelect {
  text-align: right;
  color: #1989fa;
}
</style>
